import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard/Dashboard";
import Transactions from "./components/Transactions/TransactionHistory";
import UserSettings from "./components/Users/UserSettings";
import AccountSetup from "./components/Accounts/AccountsSetup";
import UserSetup from "./components/Users/UsersSetup";
import BusinessSetup from "./components/Business/BusinessSetup";
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/transactions"
              element={
                <ProtectedRoute>
                  <Transactions />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <UserSettings />
                </ProtectedRoute>
              }
            />
            <Route
              path="/accounts-setup"
              element={
                <ProtectedRoute>
                  <AccountSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users-setup"
              element={
                <ProtectedRoute>
                  <UserSetup />
                </ProtectedRoute>
              }
            />
            <Route
              path="/business-setup"
              element={
                <ProtectedRoute>
                  <BusinessSetup />
                </ProtectedRoute>
              }
            />
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
